class KzUtils {

}

export default KzUtils;
